'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * DropdownMenu component.
 *
 * @extends {React.Component}
 * @property {Boolean} isActive Determines if the menu will be up or not.
 */
class DropdownMenu extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render() {
    const dropDownMenuClasses = classNames({
      'DropDown-menu': true,
      'is-active': this.props.isActive
    });

    return (
      <div className={dropDownMenuClasses}>
        <div className="DropDown-menuScroll">
          <ul className="DropDown-menuItems">
            {this.props.children}
          </ul>
        </div>
      </div>
    );
  }
}

DropdownMenu.propTypes = {
  isActive: React.PropTypes.bool
};

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/dropdown/dropdownMenu.jsx